import Model from '@/store/plugins/orm/Model'

export class Grid extends Model {
    static get entity () {
        return 'grids'
    }

    static fields () {
        return {
            id: this.attr(null),
            categories_column_count: this.attr(null),
            categories_row_count: this.attr(null),
            products_column_count: this.attr(null),
            products_row_count: this.attr(null),
        }
    }
}

export default Grid
